import type { WBoxInformationsContent } from "@/lib/api/cms-window-content";
import React from "react";
import styles from "./WBoxInformations.module.css";

function parseCssStringToStyle(css: string): React.CSSProperties {
    const style: React.CSSProperties = {};
    const declarations = css
        .split(";")
        .map((s) => s.trim())
        .filter(Boolean);
    for (const decl of declarations) {
        const colonIdx = decl.indexOf(":");
        if (colonIdx === -1) continue;
        const prop = decl.slice(0, colonIdx).trim();
        const value = decl.slice(colonIdx + 1).trim();
        if (!prop || !value) continue;
        const camel = prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase()) as keyof React.CSSProperties;
        (style as Record<string, string>)[camel] = value;
    }
    return style;
}

export default function WBoxInformations({ content }: WBoxInformationsProps) {
    if (!content || content.boxes.length === 0) return null;

    return (
        <section className={styles.root}>
            <ul className={styles.grid}>
                {content.boxes.map((box) => {
                    let iconWrapStyle: React.CSSProperties = {};
                    let textStyle: React.CSSProperties = {};

                    if (box.text_color) {
                        iconWrapStyle.background = box.text_color;
                        textStyle.color = box.text_color;
                    }

                    const inner = (
                        <>
                            {box.image ? (
                                <img
                                    src={box.image.href}
                                    width={box.image.width ?? undefined}
                                    height={box.image.height ?? undefined}
                                    alt=""
                                />
                            ) : (
                                <span className={styles.iconWrap} aria-hidden="true" style={iconWrapStyle}>
                                    <i className={box.icon ?? undefined} />{" "}
                                </span>
                            )}

                            <strong className={styles.name}>{box.name}</strong>
                            {box.text && <div className={styles.text} style={textStyle} dangerouslySetInnerHTML={{ __html: box.text }} />}
                        </>
                    );

                    let boxStyle: React.CSSProperties = box.background_color
                        ? parseCssStringToStyle(box.background_color)
                        : {};

                    if (box.text_color) boxStyle.color = box.text_color;

                    return (
                        <li key={box.id} className={styles.card} style={boxStyle}>
                            {box.href ? (
                                <a href={box.href} className={styles.cardLink}>
                                    {inner}
                                </a>
                            ) : (
                                inner
                            )}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export type WBoxInformationsProps = {
    content: WBoxInformationsContent | null;
};